export const formatNumber = (value: number | undefined | null, decimals: number = 0): string => {
  if (value == null) return "-"
  return value.toLocaleString("fr-FR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export const formatCurrency = (value: number | undefined | null): string => {
  if (value == null) return "-"
  return value.toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  })
}

export const formatPercent = (value: number | undefined | null, decimals: number = 1): string => {
  if (value == null) return "-"
  return `${value.toLocaleString("fr-FR", { maximumFractionDigits: decimals })} %`
}

export const formatEuros = (value: number | undefined | null): string => {
  if (value == null) return "-"
  return value.toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  })
}

export const formatPricePerSqm = (value: number | undefined | null): string => {
  if (value == null) return "-"
  return `${value.toLocaleString("fr-FR", { maximumFractionDigits: 0 })} €/m²`
}

export const formatArea = (sqMeters: number | undefined | null): string => {
  if (sqMeters == null) return "-"
  if (sqMeters >= 10000) {
    return `${(sqMeters / 10000).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} ha`
  }
  return `${sqMeters.toLocaleString("fr-FR", { maximumFractionDigits: 0 })} m²`
}
